import React, { memo, useCallback, useMemo } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Button, Typography } from "@mui/material";

const titleSx = {
  backgroundColor: "#C60C30",
  display: "flex",
  justifyContent: "center",
  color: "white",
};

const getActions = (type, disableDone, handleCancel, handleDone) => {
  switch (type) {
    case "cancelDone":
      return (
        <>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            disabled={disableDone}
            variant="contained"
            onClick={handleDone}
          >
            Done
          </Button>
        </>
      );
    case "cancelSave":
      return (
        <>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            disabled={disableDone}
            variant="contained"
            onClick={handleDone}
          >
            Save
          </Button>
        </>
      );
    case "cancelAdd":
      return (
        <>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            disabled={disableDone}
            variant="contained"
            onClick={handleDone}
          >
            Add
          </Button>
        </>
      );
    case "cancelUpdate":
      return (
        <>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            disabled={disableDone}
            variant="contained"
            onClick={handleDone}
          >
            Update
          </Button>
        </>
      );
    case "yesNo":
      return (
        <>
          <Button onClick={handleCancel}>No</Button>
          <Button
            disabled={disableDone}
            variant="contained"
            onClick={handleDone}
          >
            Yes
          </Button>
        </>
      );
    case "cancelApply":
      return (
        <>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            disabled={disableDone}
            variant="contained"
            onClick={handleDone}
          >
            Apply
          </Button>
        </>
      );
    case "ok":
      return (
        <Button variant="contained" onClick={handleCancel}>
          Ok
        </Button>
      );
    default:
      return <></>;
  }
};

function CommonDialog(props) {
  const {
    open = false,
    disableDone = false,
    type = "cancelDone",
    title = "",
    content = "",
    maxWidth = "xs",
    handleClose,
    handleDone,
  } = props;
  const onHandleClose = useCallback(() => {
    handleClose?.();
  }, [handleClose]);

  const onHandleDone = useCallback(
    (event) => {
      handleDone?.(event);
    },
    [handleDone]
  );

  const actions = useMemo(
    () => getActions(type, disableDone, onHandleClose, onHandleDone),
    [type, disableDone, onHandleClose, onHandleDone]
  );

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onHandleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={maxWidth}
    >
      {typeof title === "string" ? (
        <DialogTitle
          data-testid="dialog-title"
          id="alert-dialog-title"
          sx={titleSx}
        >
          <Typography>{title}</Typography>
        </DialogTitle>
      ) : (
        title
      )}
      <DialogContent data-testid="dialog-content" sx={{ mt: 3 }}>
        <DialogContentText sx={{ color: "black" }}>{content}</DialogContentText>
      </DialogContent>
      <DialogActions data-testid="dialog-actions">{actions}</DialogActions>
    </Dialog>
  );
}

export default memo(CommonDialog);
